import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import validator from 'validator'
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
  touched: boolean

}
export class PostalCodeComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    const programContainer = getRootComponent(field);
    field.IsDirty = false;
    FormValidationUtils.runJavascript(field);
    field.Touched = false;
  }

  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;

    FormValidationUtils.markFieldDirty(field);
    FormValidationUtils.runJavascript(field);
    FormValidationUtils.validatePostalCode(field);


    this.props.callbackElement(getRootComponent(this.props.field));
  }

  render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    // Access programContainer
    const programContainer = getRootComponent(field);

    if (editable) {
      controlArray.push(

        <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id} className="ontario-form-group" >
          {labelControlArray}    
          {!getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
            field={this.props.field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + field.LoadBindName}
            id={`${field.LoadBindName}-${field.Id}`}
          />)}
          <div key={'fdIpt_div_' + field.Id} >
            <input 
              className={classNames('ontario-input','ontario-input--7-char-width', { 'ontario-input__error': this.props.field.Touched && !this.props.field.Valid })}
              id={'fdIpt_' + field.Id}
              name={field.LoadBindName}
              key={'fdIpt_' + field.Id}
              style={{...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }) }}
              required={requiredField}
              readOnly={field.ReadOnly}
              value={field.Value || ''} // Ensure value is not null/undefined for the input
              maxLength={7}
              onBlur={this.onTextEditChange}
              onChange={(e) => {
                let elem = e.target;
                let val = elem.value;
                field.Value = val;
                FormValidationUtils.markFieldDirty(field);
                this.props.callbackElement(getRootComponent(this.props.field));

              }
              } />
          </div>
          {getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
            field={this.props.field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + field.LoadBindName}
            id={`${field.LoadBindName}-${field.Id}`}
          />)}
        </div>);
    }
    else {
      controlArray.push(  <div 
          key={'div_' + field.Datatype + '_' + field.Id} 
          className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}
        >
      
          <div key={'div2_' + field.Datatype + '_' + field.Id}>{title}</div>
          <div key={'div3_' + field.Datatype + '_' + field.Id}>{field.Value}</div>
        </div>
      );
    }

    return controlArray;

  }

}
